var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForgotPasswordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_invite_3139227_000000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 5683",
    d: "M58.915 17.36V0H12.324V17.36L0 26.076V71.389H71.241V26.075L58.915 17.36ZM64.7 27.279L58.914 31.412V23.219L64.7 27.279ZM54.106 4.809V34.79L35.619 47.867L17.132 34.793V4.809H54.106ZM12.323 31.409L6.538 27.279L12.324 23.146L12.323 31.409ZM4.809 66.581V31.937L35.619 53.729L66.429 31.937V66.654H4.809V66.581Z",
    fill: "#594AA5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPasswordIcon);
export default __webpack_public_path__ + "static/media/forgotPasswordIcon.57fc2f8b221a876d68f4e5d732d114b8.svg";
export { ForwardRef as ReactComponent };